import colors from '../../../utils/colors';

import { PasswordRuleType, PasswordStatus } from './type';

export const titleByRuleType: Record<PasswordRuleType, string> = {
  upperCase: 'A',
  lowerCase: 'a',
  number: '123',
  symbol: '@!#',
  length: '8+',
};

export const colorsByStatus: Record<PasswordStatus, string> = {
  valid: colors.success100,
  invalid: colors.error100,
  stale: colors.ink50,
};
